<template>
  <div id="box">
    <div class="historyTag">
      <historyTag :historyArr="historyArr"></historyTag>
    </div>

    <div class="topBox flex">
      <div class="topLeft flex" style="align-items: center; flex-wrap: wrap">
        <div class="flex" style="align-items: center; margin-right: 12px; margin-bottom: 4px">
          <span style="white-space: nowrap; margin-right: 8px">昵称：</span>
          <div style="width: 180px">
            <el-input v-model="query.nickName" placeholder="模糊" clearable @keyup.enter.native="searchFn" />
          </div>
        </div>
        <div class="flex" style="align-items: center; margin-right: 12px; margin-bottom: 4px">
          <span style="white-space: nowrap; margin-right: 8px">状态：</span>
          <div style="width: 140px">
            <el-select v-model="query.enabled" placeholder="全部" clearable @change="searchFn">
              <el-option v-for="o in enabledOptions" :key="String(o.value)" :label="o.label" :value="o.value" />
            </el-select>
          </div>
        </div>
        <el-button type="success" size="small" @click="searchFn">搜索</el-button>
        <el-button size="small" @click="resetFn">重置</el-button>
        <el-button type="primary" size="small" @click="openAddDialog">新增马甲</el-button>
      </div>
    </div>

    <div class="table-scroll-wrap">
    <el-table :data="tableData" border style="width: 100%; margin-top: 12px" v-loading="loading">
      <el-table-column prop="id" label="ID" width="80" align="center" />
      <el-table-column label="头像" width="80" align="center">
        <template slot-scope="scope">
          <img
            v-if="scope.row.avatarUrl"
            :src="scope.row.avatarUrl"
            style="width: 40px; height: 40px; border-radius: 50%; object-fit: cover"
            alt=""
          />
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="nickName" label="昵称" min-width="120" align="center" show-overflow-tooltip />
      <el-table-column label="启用" width="100" align="center">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.enabled"
            :active-value="1"
            :inactive-value="0"
            :disabled="isRowUpdating(scope.row)"
            @change="(val) => onToggleEnabled(scope.row, val)"
          />
        </template>
      </el-table-column>
      <el-table-column prop="sortOrder" label="排序" width="80" align="center" />
      <el-table-column prop="remark" label="备注" min-width="160" show-overflow-tooltip />
      <el-table-column prop="createTime" label="创建时间" width="170" align="center">
        <template slot-scope="scope">{{ formatTime(scope.row.createTime) }}</template>
      </el-table-column>
      <el-table-column prop="updateTime" label="更新时间" width="170" align="center">
        <template slot-scope="scope">{{ formatTime(scope.row.updateTime) }}</template>
      </el-table-column>
      <el-table-column label="操作" width="100" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button size="small" type="primary" plain @click="openEditDialog(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    </div>

    <list-pagination
      :total="tableTotal"
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
      @page-change="changePage"
      @size-change="handlePageSizeChange"
    />

    <el-dialog title="新增马甲" :visible.sync="addVisible" width="560px" :close-on-click-modal="false" @closed="onAddClosed">
      <el-form ref="addFormRef" :model="form" :rules="formRules" label-width="100px" size="small">
        <el-form-item label="昵称" prop="nickName">
          <el-input v-model="form.nickName" maxlength="64" show-word-limit placeholder="展示昵称" />
        </el-form-item>
        <el-form-item label="头像">
          <div class="avatarUploadRow">
            <img v-if="form.avatarUrl" :src="form.avatarUrl" class="avatarPreview" alt="" />
            <div v-else class="avatarPreview avatarPreview--ph">
              <i class="el-icon-user-solid"></i>
            </div>
            <div class="avatarUploadActions">
              <el-upload
                :show-file-list="false"
                :disabled="avatarUploading"
                accept="image/jpeg,image/png,image/gif,image/webp"
                :before-upload="beforeAvatarUpload"
                :http-request="uploadAvatarRequest"
              >
                <el-button size="small" type="primary" plain :loading="avatarUploading">
                  {{ avatarUploading ? "上传中…" : "上传图片" }}
                </el-button>
              </el-upload>
              <el-button v-if="form.avatarUrl" type="text" size="small" @click="clearAvatar">移除</el-button>
            </div>
          </div>
          <div class="formHint">JPG / PNG / GIF / WebP，单张不超过 5MB；保存时写入地址</div>
        </el-form-item>
        <el-form-item label="启用" prop="enabled">
          <el-radio-group v-model="form.enabled">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="排序" prop="sortOrder">
          <el-input-number v-model="form.sortOrder" :min="0" :max="999999" controls-position="right" style="width: 100%" />
          <div class="formHint">数值越小，陪审抽取时越优先</div>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="form.remark" type="textarea" :rows="2" maxlength="255" show-word-limit placeholder="内部备注，可选" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="submitForm(false)">提交</el-button>
      </span>
    </el-dialog>

    <el-dialog title="编辑马甲" :visible.sync="editVisible" width="560px" :close-on-click-modal="false" @closed="onEditClosed">
      <el-form ref="editFormRef" :model="form" :rules="formRules" label-width="100px" size="small">
        <el-form-item label="ID">
          <el-input :value="form.id" disabled />
        </el-form-item>
        <el-form-item label="昵称" prop="nickName">
          <el-input v-model="form.nickName" maxlength="64" show-word-limit placeholder="展示昵称" />
        </el-form-item>
        <el-form-item label="头像">
          <div class="avatarUploadRow">
            <img v-if="form.avatarUrl" :src="form.avatarUrl" class="avatarPreview" alt="" />
            <div v-else class="avatarPreview avatarPreview--ph">
              <i class="el-icon-user-solid"></i>
            </div>
            <div class="avatarUploadActions">
              <el-upload
                :show-file-list="false"
                :disabled="avatarUploading"
                accept="image/jpeg,image/png,image/gif,image/webp"
                :before-upload="beforeAvatarUpload"
                :http-request="uploadAvatarRequest"
              >
                <el-button size="small" type="primary" plain :loading="avatarUploading">
                  {{ avatarUploading ? "上传中…" : "上传图片" }}
                </el-button>
              </el-upload>
              <el-button v-if="form.avatarUrl" type="text" size="small" @click="clearAvatar">移除</el-button>
            </div>
          </div>
          <div class="formHint">JPG / PNG / GIF / WebP，单张不超过 5MB</div>
        </el-form-item>
        <el-form-item label="启用" prop="enabled">
          <el-radio-group v-model="form.enabled">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="排序" prop="sortOrder">
          <el-input-number v-model="form.sortOrder" :min="0" :max="999999" controls-position="right" style="width: 100%" />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="form.remark" type="textarea" :rows="2" maxlength="255" show-word-limit placeholder="可选" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="submitForm(true)">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { returnTime } from "@/util/utils";

export default {
  data() {
    return {
      historyArr: ["马甲用户"],
      loading: false,
      enabledOptions: [
        { label: "全部", value: null },
        { label: "启用", value: 1 },
        { label: "停用", value: 0 },
      ],
      query: {
        nickName: "",
        enabled: null,
      },
      tableData: [],
      pageSize: 10,
      currentPage: 1,
      tableTotal: 0,

      addVisible: false,
      editVisible: false,
      submitLoading: false,
      avatarUploading: false,
      form: {
        id: null,
        nickName: "",
        avatarUrl: "",
        enabled: 1,
        sortOrder: 0,
        remark: "",
      },
      formRules: {
        nickName: [{ required: true, message: "请填写昵称", trigger: "blur" }],
      },
    };
  },
  mounted() {
    this.fetchList(1);
  },
  methods: {
    emptyForm() {
      return {
        id: null,
        nickName: "",
        avatarUrl: "",
        enabled: 1,
        sortOrder: 0,
        remark: "",
      };
    },

    formatTime(t) {
      if (!t) return "-";
      try {
        return returnTime(t, "-", "s");
      } catch (e) {
        return String(t);
      }
    },

    resetFn() {
      this.query = { nickName: "", enabled: null };
      this.currentPage = 1;
      this.fetchList(1);
    },

    searchFn() {
      this.currentPage = 1;
      this.fetchList(1);
    },

    changePage(p) {
      this.fetchList(p);
    },

    handlePageSizeChange() {
      this.fetchList(1);
    },

    openAddDialog() {
      this.form = this.emptyForm();
      this.avatarUploading = false;
      this.addVisible = true;
      this.submitLoading = false;
      this.$nextTick(() => {
        if (this.$refs.addFormRef) this.$refs.addFormRef.clearValidate();
      });
    },

    onAddClosed() {
      this.submitLoading = false;
      this.avatarUploading = false;
      this.$nextTick(() => {
        if (this.$refs.addFormRef) this.$refs.addFormRef.clearValidate();
      });
    },

    openEditDialog(row) {
      if (!row || row.id == null) return;
      this.form = {
        id: row.id,
        nickName: row.nickName != null ? String(row.nickName) : "",
        avatarUrl: row.avatarUrl != null ? String(row.avatarUrl) : "",
        enabled: row.enabled === 0 ? 0 : 1,
        sortOrder: row.sortOrder != null ? Number(row.sortOrder) : 0,
        remark: row.remark != null ? String(row.remark) : "",
      };
      this.avatarUploading = false;
      this.editVisible = true;
      this.submitLoading = false;
      this.$nextTick(() => {
        if (this.$refs.editFormRef) this.$refs.editFormRef.clearValidate();
      });
    },

    onEditClosed() {
      this.submitLoading = false;
      this.avatarUploading = false;
      this.$nextTick(() => {
        if (this.$refs.editFormRef) this.$refs.editFormRef.clearValidate();
      });
    },

    beforeAvatarUpload(file) {
      const allow = ["image/jpeg", "image/png", "image/gif", "image/webp"];
      if (!allow.includes(file.type)) {
        this.$message.error("请上传 JPG / PNG / GIF / WebP 图片");
        return false;
      }
      const max = 5 * 1024 * 1024;
      if (file.size > max) {
        this.$message.error("图片不能超过 5MB");
        return false;
      }
      return true;
    },

    normalizeUploadedImageUrl(path) {
      if (!path || typeof path !== "string") return "";
      const p = path.trim();
      if (/^https?:\/\//i.test(p)) return p;
      const base = "https://hzshixiang.site";
      return p.startsWith("/") ? base + p : `${base}/${p}`;
    },

    uploadAvatarRequest(option) {
      const no = `${Date.now()}_${Math.round(Math.random() * 1000)}`;
      const fd = new FormData();
      fd.append("file", option.file);
      fd.append("no", no);
      this.avatarUploading = true;
      this.$https(this.$api.api.uploadImg, fd, "POST")
        .then((res) => {
          const body = res && res.data;
          const code = body && body.code;
          const uploadOk =
            body &&
            (code === 200 || code === 1 || code === 0) &&
            body.data != null &&
            !(typeof body.data === "string" && body.data === "null");
          if (uploadOk) {
            const d = body.data;
            const raw =
              typeof d === "string" ? d : (d && (d.path || d.url || d.fileUrl || d.fullPath)) || "";
            const url = this.normalizeUploadedImageUrl(String(raw).trim());
            if (url) {
              this.form.avatarUrl = url;
              if (typeof option.onSuccess === "function") option.onSuccess(body, option.file);
            } else {
              this.$message.error("未返回图片地址");
              if (typeof option.onError === "function") option.onError(new Error("empty url"));
            }
          } else {
            this.$message.error((body && body.msg) || "上传失败");
            if (typeof option.onError === "function") option.onError(new Error("fail"));
          }
        })
        .catch(() => {
          this.$message.error("上传失败");
          if (typeof option.onError === "function") option.onError(new Error("network"));
        })
        .finally(() => {
          this.avatarUploading = false;
        });
    },

    clearAvatar() {
      this.form.avatarUrl = "";
    },

    submitForm(isEdit) {
      const ref = isEdit ? this.$refs.editFormRef : this.$refs.addFormRef;
      if (!ref) return;
      if (this.avatarUploading) {
        this.$message.warning("图片上传中，请稍候");
        return;
      }
      ref.validate((valid) => {
        if (!valid) return;
        if (isEdit && this.form.id == null) return;
        const payload = {
          id: isEdit ? this.form.id : null,
          nickName: this.form.nickName,
          avatarUrl: this.form.avatarUrl || null,
          enabled: this.form.enabled,
          sortOrder: this.form.sortOrder != null ? this.form.sortOrder : 0,
          remark: this.form.remark || null,
        };
        this.submitLoading = true;
        this.$https(this.$api.api.secondhandSockPuppetSave, payload, "POST")
          .then((res) => {
            if (res.data && res.data.code == 200) {
              this.$message.success("保存成功");
              this.addVisible = false;
              this.editVisible = false;
              this.fetchList(this.currentPage);
            } else {
              this.$message.error((res.data && res.data.msg) || "保存失败");
            }
          })
          .finally(() => {
            this.submitLoading = false;
          });
      });
    },

    isRowUpdating(row) {
      return !!(row && row.__saving);
    },

    onToggleEnabled(row, val) {
      if (!row || row.id == null) return;
      const next = val === 0 ? 0 : 1;
      const prev = next === 1 ? 0 : 1;
      this.$set(row, "__saving", true);
      const payload = {
        id: row.id,
        nickName: row.nickName != null ? String(row.nickName) : "",
        avatarUrl: row.avatarUrl != null ? String(row.avatarUrl) : null,
        enabled: next,
        sortOrder: row.sortOrder != null ? Number(row.sortOrder) : 0,
        remark: row.remark != null ? String(row.remark) : null,
      };
      this.$https(this.$api.api.secondhandSockPuppetSave, payload, "POST")
        .then((res) => {
          if (!(res.data && res.data.code == 200)) {
            this.$message.error((res.data && res.data.msg) || "保存失败");
            this.$set(row, "enabled", prev);
          }
        })
        .catch(() => {
          this.$message.error("保存失败");
          this.$set(row, "enabled", prev);
        })
        .finally(() => {
          this.$set(row, "__saving", false);
        });
    },

    fetchList(page) {
      this.loading = true;
      const obj = { page: page || 1, size: this.pageSize };
      const nn = String(this.query.nickName || "").trim();
      if (nn) obj.nickName = nn;
      if (this.query.enabled != null) obj.enabled = this.query.enabled;

      this.$https(this.$api.api.secondhandSockPuppetPage, obj, "POST")
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.tableData = res.data.data || [];
            this.tableTotal = res.data.size || 0;
          } else {
            this.tableData = [];
            this.tableTotal = 0;
            this.$message.error((res.data && res.data.msg) || "查询失败");
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="less" scoped>
#box {
  width: 100%;
  .topBox {
    width: 100%;
    align-items: center;
    justify-content: space-between;
    margin-top: 10px;
  }
  .topLeft {
    align-items: center;
  }
  .formHint {
    font-size: 12px;
    color: #909399;
    margin-top: 4px;
  }
  .avatarUploadRow {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
  }
  .avatarPreview {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    object-fit: cover;
    border: 1px solid #e4e7ed;
    flex-shrink: 0;
  }
  .avatarPreview--ph {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f5f7fa;
    color: #c0c4cc;
    font-size: 28px;
  }
  .avatarUploadActions {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/secondhandSockPuppet/index.vue